import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import {
    IAttributeConfData,
    IAttributeConfDataOption
} from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { Client } from '@df/core/service/client';
import { Subscription } from 'rxjs';
import { ConfigurableOptionWarningService } from './configurable-option-warning.service';
export interface IConfigurableOptionWarning {
    title: string;
    subtitle: string;
}
@Directive({
    selector: '[configurableOptionWarningTrigger]',
    standalone: true
})
export class ConfigurableOptionWarningTriggerDirective implements OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    @Input()
    configurableOptionWarningTrigger: { attribute: IAttributeConfData; option: IAttributeConfDataOption };

    constructor(
        private configurableOptionWarningService: ConfigurableOptionWarningService,
        private elementRef: ElementRef,
        private client: Client
    ) {
        this.subscriptions.add(this.client.obs.scroll.subscribe(() => this.unsetWarning()));
    }

    @HostListener('mouseenter')
    setWarning() {
        this.configurableOptionWarningService.setWarning(
            this.configurableOptionWarningTrigger.attribute,
            this.configurableOptionWarningTrigger.option,
            this.elementRef.nativeElement
        );
    }
    @HostListener('mouseleave')
    unsetWarning() {
        this.configurableOptionWarningService.unsetWarning(
            this.configurableOptionWarningTrigger.attribute,
            this.configurableOptionWarningTrigger.option
        );
    }

    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }
}
